var map = {
	"./day/blizzard.jpg": 4306,
	"./day/clear.jpg": 8071,
	"./day/cloudy.jpg": 605,
	"./day/foggy.jpg": 8066,
	"./day/misty.jpg": 3,
	"./day/partly-cloudy.jpg": 2254,
	"./day/rainy.jpg": 1593,
	"./day/snowy.jpg": 6547,
	"./day/thunder.jpg": 513,
	"./night/blizzard.jpg": 2179,
	"./night/clear.jpg": 9396,
	"./night/cloudy.jpg": 8991,
	"./night/foggy.jpg": 8349,
	"./night/misty.jpg": 9049,
	"./night/partly-cloudy.jpg": 6533,
	"./night/rainy.jpg": 1032,
	"./night/snowy.jpg": 8727,
	"./night/thunder.jpg": 8358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5996;